import { useEffect, useRef } from 'react'
import { startOrb, type OrbAnalysers } from '../lib/orbRenderer'

interface OrbProps {
  /** Null until a session starts. The orb animates idle without them. */
  analysers: OrbAnalysers | null
}

export function Orb({ analysers }: OrbProps): JSX.Element {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  // Read by the render loop rather than passed into it, so the orb picks up a
  // session starting without being torn down and restarted mid-spin.
  const analysersRef = useRef(analysers)
  useEffect(() => {
    analysersRef.current = analysers
  }, [analysers])

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    return startOrb(canvas, () => analysersRef.current)
  }, [])

  // The backing store is sized from clientWidth every frame, so no resize
  // listener is needed. The loop starts before any connection: the orb is alive
  // on the "tap to start" screen, and the tap joins something already running.
  return <canvas ref={canvasRef} className="block aspect-square w-[min(72vw,300px)]" />
}
